import { render } from "./HeaderBack.vue?vue&type=template&id=c7baa4be"
import script from "./HeaderBack.vue?vue&type=script&lang=js"
export * from "./HeaderBack.vue?vue&type=script&lang=js"

import "./HeaderBack.vue?vue&type=style&index=0&id=c7baa4be&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__